module.exports = __webpack_public_path__ + "img/menu_icon.ac079f77.svg";